import { Button, TextField } from '@mui/material'
import { useState } from 'react'
import defaulrCamImg from "../../../assets/images/photo.png"
import PopUpAlert from '../../../component/PopUpAlert'
import { NotificationAPI } from '../../../api/NotificationAPI'

const CreateGroup = ({ setAnchorEl, userIds, userInfo, setIsUpdate, clubId }) => {
    
    const [message, setMessage] = useState({ type: '', content: '',id:'' });
    const [isLoading, setIsLoading] = useState(false);
    const [image, setImage] = useState("");
    const [imagePre, setImagePre] = useState(defaulrCamImg);
    const [groupName, setGroupName] = useState('');

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        const maxSizeInMB = 5;
        if (file.type === "image/webp" || file.type === "image/jpg" || file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif") {

            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > maxSizeInMB) {
                setMessage({ type: 'info', content: "upload image under 5 MB", id: Date.now() });
            }
            else {
                setImage(file);
                setImagePre(URL.createObjectURL(file));
            }
        } else {
            setMessage({ type: 'warning', content: "upload .jpg, .jpeg, .png, .gif,.webp file",id:Date.now() });
        }
    };

    const handleCreateGroup = async() => {
        try {
            const groupData={
                groupName:groupName,
                userIds: userIds,
                createdBy: userInfo.userId,
                clubId: clubId
            }
            await NotificationAPI.postCreateChatGroup(groupData,image);
            setIsUpdate(true);
            setAnchorEl(null);
        } catch (error) {

        }
    }
    return (
        <div className='sm_create_chat_group_container'>
            <PopUpAlert id={message.id} message={message.content} type={message.type} />
            <div className='sm_create_chat_group_img'>
                <div className="sm_group_profile_image">
                    <label htmlFor="file_upload" className="sm_group_profile_image_edit"></label>
                    <label className="sm_group_profile_image_preview">
                        <img
                            loading="lazy"
                            src={imagePre}
                            alt=""
                        />
                    </label>
                    <input
                        type="file"
                        id="file_upload"
                        name="image"
                        onChange={handleImageUpload}
                    />
                </div>
                <p>Add group icon</p>
            </div>
            <TextField onChange={(event)=>setGroupName(event.target.value)} className='sm_search_user_to_add_in_group' fullWidth size='small' label="Group name" variant='standard' />
            <div className='sm_add_user_in_group_nav_buttons'>
                <Button variant='contained' onClick={() => handleCreateGroup()}>Create</Button>
                <Button color='error' variant='outlined' onClick={() => setAnchorEl(null)}>Cancel</Button>
            </div>
        </div>
    )
}

export default CreateGroup